class AccountSettings.InstagramListeningActiveHashtagsCountView extends Backbone.View

  template: JST['backbone/templates/account_settings/topics/instagram_listening_hashtags_count']

  initialize:() =>
    @maxActiveHashtags = 30

  render:()->
    @$el.html(@template({maxActiveHashtags : @maxActiveHashtags}))
    @

  setCounts:(contentsCount)->
    @activeCount = contentsCount
    @$('#hashtag-contents-count').html(contentsCount)

  getCounts:->
    @activeCount
